import { useOutletContext } from "react-router-dom";

import { Flow, FlowVersion } from "src/api/flowTypes";
import { Module } from "src/api/modulesApi";
import { ReviewDb, WorkspaceDataplane } from "src/clients/flow-api";

export type AuthoringPageContext = {
  flow: Flow;
  version: FlowVersion;
  workspace: WorkspaceDataplane;
  modules: Module[] | [];
  orgId: string;
  isRevision: boolean;
  review: ReviewDb;
  simulationId?: string;
};

export const useAuthoringContext = () => {
  const context = useOutletContext<AuthoringPageContext>();
  if (
    !context ||
    !context.flow ||
    !context.version ||
    !context.workspace ||
    context.isRevision === undefined
  ) {
    throw new Error(
      "`useAuthoringContext` hook must be used within an authoring page route",
    );
  }

  return context;
};

type FlowPagesContext = {
  flow: Flow;
  workspace: WorkspaceDataplane;
  modules: Module[] | [];
  orgId: string;
};

export const useFlowContext = () => {
  const context = useOutletContext<FlowPagesContext>();
  if (!context || !context.flow || !context.workspace) {
    throw new Error(
      "`useFlowContext` hook must be used within a flow pages route",
    );
  }
  return context;
};

type WorkspacePagesContext = {
  workspace: WorkspaceDataplane;
  modules: Module[];
  orgId: string;
};

export const useWorkspaceContext = () => {
  const context = useOutletContext<WorkspacePagesContext>();
  if (!context || !context.workspace) {
    throw new Error(
      "`useWorkspaceContext` hook must be used within a workspace pages route",
    );
  }

  return context;
};
